import React from 'react';
import {
  Form, Divider, Input, Checkbox,
} from 'antd';
import {
  AndroidFilled, AppleFilled, WindowsFilled,
} from '@ant-design/icons';
import getFormItemRules from '../../shared/form-helper';
import TestCampaign from '../test-campaign';

const { TextArea } = Input;

const PushCampaign = (properties) => {
  const { form, next, selectCampaign } = properties;

  const labelFn = {
    android: (<>
      <AndroidFilled />
      Android
    </>),
    ios: (<>
      <AppleFilled />
      iOS
    </>),
    windows: (<>
      <WindowsFilled />
      Windows
    </>),
  };

  const options = [
    { label: labelFn.android, value: 'android' },
    { label: labelFn.ios, value: 'ios', disabled: true },
    { label: labelFn.windows, value: 'web', disabled: true },
  ];

  return (
    <>
      <Divider />
      <div>
        <Form.Item
          name="device_type"
          label=" Choose the platforms you want to run the campaign for:"
          rules={[
            ...getFormItemRules({
              required: true,
            }),
          ]}
        >
          <Checkbox.Group options={options} />
        </Form.Item>
        <Form.Item
          name="message_title"
          label="Message Title"
          rules={[
            ...getFormItemRules({
              required: true,
            }),
          ]}
        >
          <Input style={{ width: '300px' }} />
        </Form.Item>
        <Form.Item
          name="push_template_content"
          label="Message"
          rules={[
            ...getFormItemRules({
              required: true,
            }),
          ]}
        >
          <TextArea style={{ width: '500px' }} rows={3} maxLength={300} />
        </Form.Item>
      </div>
      <Divider />
      <TestCampaign form={form} next={next} selectCampaign={selectCampaign} />
    </>
  );
};

export default PushCampaign;
